import { createRoot } from 'react-dom/client';
import App from './app/_app.tsx';
import setUpSentryErrorMonitoring from './error-sentry-monitoring.ts';

// setup error monitoring
setUpSentryErrorMonitoring();
createRoot(document.getElementById('root')!).render(<App />);
